/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = OurBranch
 *
 * 2 = AtHome
 */
export enum HandoverOptions {
  OurBranch = 1,
  AtHome = 2,
}
